import type { TFunction } from 'i18next';
import { z } from 'zod';

const LETTER = /\p{L}/u;
const DIGIT = /\d/;

/**
 * BR-ACC-02: не короче 8 и не длиннее 64 символов, буквы и хотя бы одна цифра,
 * новый пароль не совпадает с текущим; повтор совпадает с новым (ACC 4.7.4, модалка «Сменить пароль»).
 * Имена полей = поля контракта, поэтому 422 ложатся в поля без переименования.
 */
export function createChangePasswordSchema(t: TFunction<'auth'>) {
  const required = t('changePassword.validation.required');
  return z
    .object({
      current_password: z.string().min(1, required),
      new_password: z
        .string()
        .min(1, required)
        .min(8, t('changePassword.validation.tooShort'))
        .max(64, t('changePassword.validation.tooLong'))
        .refine(
          (value) => LETTER.test(value) && DIGIT.test(value),
          t('changePassword.validation.lettersAndDigit'),
        ),
      new_password_repeat: z.string().min(1, required),
    })
    .superRefine((values, context) => {
      if (values.new_password && values.new_password === values.current_password) {
        context.addIssue({
          code: 'custom',
          path: ['new_password'],
          message: t('changePassword.validation.same'),
        });
      }
      if (values.new_password_repeat && values.new_password_repeat !== values.new_password) {
        context.addIssue({
          code: 'custom',
          path: ['new_password_repeat'],
          message: t('changePassword.validation.mismatch'),
        });
      }
    });
}

export type ChangePasswordValues = z.infer<ReturnType<typeof createChangePasswordSchema>>;
